import OrderPaymentStatus from './OrderPaymentStatus'

export default OrderPaymentStatus
